import { render, staticRenderFns } from "./Accompany.vue?vue&type=template&id=c4c90862&scoped=true&"
import script from "./Accompany.vue?vue&type=script&lang=js&"
export * from "./Accompany.vue?vue&type=script&lang=js&"
import style0 from "./Accompany.vue?vue&type=style&index=0&id=c4c90862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c90862",
  null
  
)

export default component.exports